import {
  FETCH_ORDER_CALCULATE_PENDING,
  FETCH_ORDER_CALCULATE_REJECTED,
  FETCH_ORDER_CALCULATE_FULFILLED,
} from 'constants/orderCalculateQuestions';

const initialState = {
  pending: true,
  orderQuestions: {},
  error: {},
  success: false,
};

export const orderCalculateQuestions = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_ORDER_CALCULATE_FULFILLED:
      return {
        ...state,
        orderQuestions: action.response,
        pending: false,
        success: true,
      };

    case FETCH_ORDER_CALCULATE_REJECTED:
      return { ...state, pending: false, error: action.error };

    case FETCH_ORDER_CALCULATE_PENDING:
      return {
        ...state,
        error: {},
      };

    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/reducers/orderCalculateQuestions.js